import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["details"]

  toggle() {
    const details = this.detailsTarget
    if (details.style.display === "none") {
      details.style.display = "block"
    } else {
      details.style.display = "none"
    }
  }
}